import cn from "classnames";
import { Datetime, Field, Select } from "components/shared/form";
import { organizationDemoPeriodStatuses } from "helpers/enums/organizationDemoPeriodStatuses";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { editOrganizationDemoPeriod, getOrganizationDemoPeriod } from "sources/admin/demoPeriod";

const DemoPeriodForm = ({ organizationId, back }) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});

    useEffect(() => {
        getOrganizationDemoPeriod(organizationId).then((res) => {
            setData(res);
            setLoading(false);
        });
    }, []);

    const setValue = ({ name, value }) => setData((prev) => ({ ...prev, [name]: value }));

    const save = () => {
        setLoading(true);
        const params = {
            ...data,
            startedAt: data.startedAt ? moment(data.startedAt).utc().format() : undefined,
            lastNotifiedAt: data.lastNotifiedAt ? moment(data.lastNotifiedAt).utc().format() : undefined,
        };
        editOrganizationDemoPeriod(params).then((res) => {
            if (res) {
                back();
            } else {
                setLoading(false);
            }
        });
    };

    if (!data && !loading) {
        return <div className="p-3">Данные не найдены</div>;
    }

    return (
        <div className={cn("modal-window__form", { loading })}>
            <Field
                label="ID"
                labelWrapper="col-sm-4 col-form-label col-form-label-sm text-md-right text-sm-left"
                fieldWrapper="col-sm-8"
                value={data.id}
                inputProps={{ name: "id", disabled: true }}
                onChange={setValue}
            />
            <Field
                label="Document ID"
                labelWrapper="col-sm-4 col-form-label col-form-label-sm text-md-right text-sm-left"
                fieldWrapper="col-sm-8"
                value={data.documentId ?? ""}
                inputProps={{ name: "documentId" }}
                onChange={setValue}
            />
            <Datetime
                label="Дата начала"
                labelWrapper="col-sm-4 col-form-label col-form-label-sm text-md-right text-sm-left"
                wrapper="col-sm-8"
                value={data.startedAt}
                inputProps={{ name: "startedAt" }}
                onChange={setValue}
                inPortal
            />
            <Datetime
                label="Дата последнего уведомления"
                labelWrapper="col-sm-4 col-form-label col-form-label-sm text-md-right text-sm-left"
                wrapper="col-sm-8"
                value={data.lastNotifiedAt}
                inputProps={{ name: "lastNotifiedAt" }}
                onChange={setValue}
                inPortal
            />
            <Select
                label="Статус"
                labelWrapper="col-sm-4 col-form-label col-form-label-sm text-md-right text-sm-left"
                fieldWrapper="col-sm-8"
                menuPortalTarget={document.body}
                value={data.status}
                inputProps={{ name: "status" }}
                onChange={setValue}
                options={organizationDemoPeriodStatuses}
            />
            <div className="modal-window__footer modal-window__footer--right">
                <div className="btn btn-secondary btn-sm mr-2" onClick={back}>
                    Отменить
                </div>
                <div className="btn btn-brand btn-sm" onClick={save}>
                    Сохранить
                </div>
            </div>
        </div>
    );
};

export default DemoPeriodForm;
